import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ActualizarNotificacionLeidaService = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Notificacion/ActualizarNotificacionesLeida",
           values, customConfig
        );
        return resultado
    } catch (error) {
        console.log(error);
    }
}
export { ActualizarNotificacionLeidaService };